import { render } from "./Fab.vue?vue&type=template&id=b9894e96&scoped=true"
import script from "./Fab.vue?vue&type=script&lang=js"
export * from "./Fab.vue?vue&type=script&lang=js"

import "./Fab.vue?vue&type=style&index=0&id=b9894e96&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\orcamento-online-concreto\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9894e96"]])

export default __exports__